<template>
  <div>
    <report-panel :anchor="''" v-if="report.companyoverview.webpresences.length > 0">
      <div slot="title">Online Presence</div>
      <div slot="body">
        <!-- panel content start -->
        <table class="table table-striped" id="social-media-table">
          <tbody>
            <tr v-for="webpresence in report.companyoverview.webpresences" :key="webpresence.id">
              <td>
                <span v-bind:class="getWebIcon(webpresence.presencetype.name)"></span>
                {{ webpresence.presencetype.name }}
              </td>
              <td v-if="webpresence.presencetype.type === 'website'">
                <a v-bind:href="webpresence.url" target="_blank">
                  {{ webpresence.url }}
                </a>
              </td>
              <td v-if="webpresence.presencetype.type === 'social'">
                <a v-bind:href="webpresence.url" target="_blank">
                  {{ isEmptyMessage(webpresence.profile_name) }}
                </a>
              </td>
            </tr>
          </tbody>
        </table>
        <!-- panel content end -->
      </div>
    </report-panel>
  </div>
</template>

<script>
import toolsMixin from '@/components/reports/ToolsMixin';
import ReportPanel from '@/components/reports/components/ReportPanel';

export default {
  components: {
    ReportPanel,
  },
  mixins: [toolsMixin],
  props: ['report', 'showAnchor'],
  computed: {
    anchor() {
      if (this.showAnchor) {
        return '#socialmedia';
      }
      return '';
    },
  },
};
</script>
